import { ELSTokenServiceRegistrar } from '@els/els-ui-common-react';
import { isEmbeddedInIframe } from './app.config';
import { IframeEvent, SessionStatusResponseMessage } from '../../pages/ai-chat/ai-chat.constants';
import { isAllowedMessageOrigin } from '../../pages/ai-chat/ai-chat.utilities';

// Posted to window.parent so an embedding iframe (e.g. Sherpath AI) gets a chance to
// reboot/reload the app itself before we navigate the inner frame to the timeout page.
export const notifyParentOfSessionExpired = (): void => {
  if (isEmbeddedInIframe()) {
    window.parent.postMessage({ type: IframeEvent.SHERPATH_AI_SESSION_EXPIRED }, '*');
  }
};

const buildSessionStatusResponse = (requestId?: string): SessionStatusResponseMessage => ({
  type: IframeEvent.SHERPATH_AI_SESSION_STATUS_RESPONSE,
  isValid: ELSTokenServiceRegistrar.isValidToken(),
  timeToExpiration: ELSTokenServiceRegistrar.getTimeToExpiration(),
  ...(requestId ? { requestId } : {}),
});

// Lets an embedding host ask this app for its current session/token status on demand,
// rather than only reacting to the SESSION_EXPIRED push. Replies to event.source (not
// window.parent) so the response reaches whichever frame actually sent the request.
export const handleSessionStatusRequest = (event: MessageEvent): void => {
  if (!isEmbeddedInIframe() || !isAllowedMessageOrigin(event.origin)) {
    return;
  }
  if (event.data?.type !== IframeEvent.SHERPATH_AI_SESSION_STATUS_REQUEST) {
    return;
  }
  const source = event.source as Window;
  source?.postMessage(buildSessionStatusResponse(event.data?.requestId), event.origin);
};
